import { useState } from 'react';
import Header from '../../components/feature/Header';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';
import Input from '../../components/base/Input';

export default function CommunicationPage() {
  const [activeTab, setActiveTab] = useState('data-input');
  const [showProcessModal, setShowProcessModal] = useState(false);

  const renderDataInput = () => (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">数据接入 - 多渠道沟通记录</h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="电话录音接入">
          <div className="space-y-4">
            <div className="bg-blue-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-phone-line text-blue-600"></i>
                <span className="font-medium text-blue-800">ASR转写引擎</span>
              </div>
              <div className="text-sm text-blue-700">
                今日处理 <span className="font-bold">45</span> 通电话录音
              </div>
            </div>
            
            <div className="space-y-3">
              <h4 className="font-medium text-gray-900">录音处理状态</h4>
              {[
                {
                  caller: '张总监',
                  target: '李明(候选人)',
                  duration: '12分35秒',
                  time: '2024-01-15 14:30',
                  status: 'completed',
                  accuracy: 96.5,
                  summary: '讨论前端开发岗位，候选人表示感兴趣'
                },
                {
                  caller: '王顾问',
                  target: '阿里巴巴HR',
                  duration: '8分22秒',
                  time: '2024-01-15 15:20',
                  status: 'processing',
                  accuracy: 0,
                  summary: '处理中...'
                },
                {
                  caller: '李经理',
                  target: '赵六(候选人)',
                  duration: '15分18秒',
                  time: '2024-01-15 16:10',
                  status: 'completed',
                  accuracy: 94.2,
                  summary: '薪资谈判，候选人期望调整'
                }
              ].map((call, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center justify-between mb-2">
                    <div>
                      <h5 className="font-medium text-gray-900">{call.caller} ↔ {call.target}</h5>
                      <p className="text-sm text-gray-600">{call.time} · {call.duration}</p>
                    </div>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      call.status === 'completed' ? 'bg-green-100 text-green-800' :
                      call.status === 'processing' ? 'bg-yellow-100 text-yellow-800' :
                      'bg-red-100 text-red-800'
                    }`}>
                      {call.status === 'completed' ? '已完成' :
                       call.status === 'processing' ? '处理中' : '失败'}
                    </span>
                  </div>
                  {call.status === 'completed' && (
                    <>
                      <div className="text-sm text-gray-600 mb-2">
                        转写准确率: <span className="font-medium text-green-600">{call.accuracy}%</span>
                      </div>
                      <div className="bg-blue-50 p-3 rounded text-sm text-blue-800">
                        <strong>AI摘要:</strong> {call.summary}
                      </div>
                    </>
                  )}
                  <div className="flex justify-end space-x-2 mt-3">
                    <Button size="sm" variant="outline">播放录音</Button>
                    <Button size="sm" variant="outline">查看转写</Button>
                    {call.status === 'completed' && (
                      <Button size="sm">确认摘要</Button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Card>

        <Card title="IM聊天拉取">
          <div className="space-y-4">
            <div className="bg-green-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-chat-3-line text-green-600"></i>
                <span className="font-medium text-green-800">多平台接入</span>
              </div>
              <div className="text-sm text-green-700">
                已接入 <span className="font-bold">4</span> 个主要沟通平台
              </div>
            </div>
            
            <div className="space-y-3">
              <h4 className="font-medium text-gray-900">平台接入状态</h4>
              {[
                { platform: '企业微信', status: 'connected', messages: 156, lastSync: '2024-01-15 16:30' },
                { platform: '钉钉', status: 'connected', messages: 89, lastSync: '2024-01-15 16:25' },
                { platform: '邮件系统', status: 'connected', messages: 234, lastSync: '2024-01-15 16:20' },
                { platform: 'LinkedIn', status: 'error', messages: 0, lastSync: '连接失败' }
              ].map((platform, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded">
                  <div className="flex items-center space-x-3">
                    <span className={`w-3 h-3 rounded-full ${
                      platform.status === 'connected' ? 'bg-green-500' : 'bg-red-500'
                    }`}></span>
                    <div>
                      <div className="font-medium text-gray-900">{platform.platform}</div>
                      <div className="text-sm text-gray-600">
                        {platform.status === 'connected' ? 
                          `${platform.messages}条消息 · ${platform.lastSync}` : 
                          platform.lastSync
                        }
                      </div>
                    </div>
                  </div>
                  <div className="flex space-x-2">
                    {platform.status === 'error' ? (
                      <Button size="sm" variant="outline">重新连接</Button>
                    ) : (
                      <Button size="sm" variant="outline">同步设置</Button>
                    )}
                  </div>
                </div>
              ))}
            </div>
            
            <div className="border-t pt-4">
              <h4 className="font-medium text-gray-900 mb-3">最新聊天记录</h4>
              <div className="space-y-2">
                {[
                  {
                    platform: '企业微信',
                    participants: '王顾问 ↔ 张三',
                    preview: '关于阿里前端岗位的面试安排...',
                    time: '16:25',
                    unprocessed: true
                  },
                  {
                    platform: '邮件',
                    participants: '李经理 ↔ 腾讯HR',
                    preview: '候选人简历已发送，请查收...',
                    time: '15:40',
                    unprocessed: false
                  }
                ].map((chat, index) => (
                  <div key={index} className="flex items-center justify-between p-2 bg-white rounded border">
                    <div className="flex items-center space-x-3">
                      <div className={`w-2 h-2 rounded-full ${chat.unprocessed ? 'bg-orange-500' : 'bg-gray-300'}`}></div>
                      <div>
                        <div className="text-sm font-medium text-gray-900">{chat.participants}</div>
                        <div className="text-xs text-gray-500">{chat.platform} · {chat.preview}</div>
                      </div>
                    </div>
                    <div className="text-xs text-gray-500">{chat.time}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Card>
      </div>

      {/* 合规性管理 */}
      <Card title="合规性管理">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <h4 className="font-medium text-gray-900 mb-3">数据合规检查</h4>
            <div className="space-y-2">
              <div className="flex items-center justify-between p-2 bg-green-50 rounded">
                <span className="text-sm text-green-700">隐私保护</span>
                <i className="ri-check-line text-green-600"></i>
              </div>
              <div className="flex items-center justify-between p-2 bg-green-50 rounded">
                <span className="text-sm text-green-700">数据加密</span>
                <i className="ri-check-line text-green-600"></i>
              </div>
              <div className="flex items-center justify-between p-2 bg-yellow-50 rounded">
                <span className="text-sm text-yellow-700">授权确认</span>
                <i className="ri-alert-line text-yellow-600"></i>
              </div>
              <div className="flex items-center justify-between p-2 bg-green-50 rounded">
                <span className="text-sm text-green-700">存储安全</span>
                <i className="ri-check-line text-green-600"></i>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">接入权限管理</h4>
            <div className="space-y-2">
              {[
                { user: '张总监', platforms: ['企业微信', '邮件'], level: 'full' },
                { user: '李经理', platforms: ['企业微信'], level: 'limited' },
                { user: '王顾问', platforms: ['钉钉'], level: 'limited' }
              ].map((user, index) => (
                <div key={index} className="p-2 bg-gray-50 rounded">
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-sm font-medium text-gray-900">{user.user}</span>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      user.level === 'full' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'
                    }`}>
                      {user.level === 'full' ? '完全权限' : '受限权限'}
                    </span>
                  </div>
                  <div className="text-xs text-gray-600">
                    {user.platforms.join(', ')}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">快速操作</h4>
            <div className="space-y-2">
              <Button variant="outline" className="w-full justify-start" size="sm">
                <i className="ri-settings-line mr-2"></i>
                接入配置
              </Button>
              <Button variant="outline" className="w-full justify-start" size="sm">
                <i className="ri-shield-check-line mr-2"></i>
                合规检查
              </Button>
              <Button variant="outline" className="w-full justify-start" size="sm">
                <i className="ri-refresh-line mr-2"></i>
                手动同步
              </Button>
              <Button variant="outline" className="w-full justify-start" size="sm">
                <i className="ri-download-line mr-2"></i>
                导出记录
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );

  const renderAIProcessing = () => (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">AI处理 - 智能分析与提取</h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="主题聚类分析">
          <div className="space-y-4">
            <div className="bg-purple-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-bubble-chart-line text-purple-600"></i>
                <span className="font-medium text-purple-800">智能聚类</span>
              </div>
              <div className="text-sm text-purple-700">
                已分析 <span className="font-bold">1,234</span> 条沟通记录
              </div>
            </div>
            
            <div className="space-y-3">
              <h4 className="font-medium text-gray-900">主题分布</h4>
              {[
                {
                  topic: '薪资谈判',
                  count: 156,
                  percentage: 35,
                  sentiment: 'neutral',
                  keywords: ['薪资', '期望', '调整', '谈判']
                },
                {
                  topic: '面试安排',
                  count: 134,
                  percentage: 30,
                  sentiment: 'positive',
                  keywords: ['面试', '时间', '安排', '确认']
                },
                {
                  topic: '职位咨询',
                  count: 89,
                  percentage: 20,
                  sentiment: 'positive',
                  keywords: ['职位', '要求', '发展', '团队']
                },
                {
                  topic: '入职流程',
                  count: 67,
                  percentage: 15,
                  sentiment: 'positive',
                  keywords: ['入职', '流程', '材料', '准备']
                }
              ].map((topic, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center space-x-2">
                      <h5 className="font-medium text-gray-900">{topic.topic}</h5>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        topic.sentiment === 'positive' ? 'bg-green-100 text-green-800' :
                        topic.sentiment === 'negative' ? 'bg-red-100 text-red-800' :
                        'bg-yellow-100 text-yellow-800'
                      }`}>
                        {topic.sentiment === 'positive' ? '积极' :
                         topic.sentiment === 'negative' ? '消极' : '中性'}
                      </span>
                    </div>
                    <span className="text-sm font-medium text-blue-600">{topic.count}条</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
                    <div className="bg-blue-500 h-2 rounded-full" style={{width: `${topic.percentage}%`}}></div>
                  </div>
                  <div className="flex flex-wrap gap-1">
                    {topic.keywords.map((keyword, i) => (
                      <span key={i} className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs">
                        {keyword}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Card>

        <Card title="关键信息抽取">
          <div className="space-y-4">
            <div className="bg-orange-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-search-eye-line text-orange-600"></i>
                <span className="font-medium text-orange-800">信息提取引擎</span>
              </div>
              <div className="text-sm text-orange-700">
                自动提取 <span className="font-bold">8</span> 类关键信息
              </div>
            </div>
            
            <div className="space-y-3">
              <h4 className="font-medium text-gray-900">提取结果示例</h4>
              <div className="border border-gray-200 rounded-lg p-4">
                <div className="flex items-center justify-between mb-3">
                  <h5 className="font-medium text-gray-900">张三 - 薪资谈判记录</h5>
                  <span className="text-sm text-gray-500">2024-01-15 14:30</span>
                </div>
                
                <div className="space-y-3">
                  <div className="grid grid-cols-2 gap-4">
                    <div className="bg-blue-50 p-3 rounded">
                      <div className="text-sm font-medium text-blue-800">人才信息</div>
                      <div className="text-sm text-blue-700 mt-1">
                        • 当前薪资: 25K<br/>
                        • 期望薪资: 35K<br/>
                        • 到岗时间: 1个月
                      </div>
                    </div>
                    <div className="bg-green-50 p-3 rounded">
                      <div className="text-sm font-medium text-green-800">客户信息</div>
                      <div className="text-sm text-green-700 mt-1">
                        • 预算范围: 30K-40K<br/>
                        • 紧急程度: 高<br/>
                        • 决策周期: 1周内
                      </div>
                    </div>
                  </div>
                  
                  <div className="bg-purple-50 p-3 rounded">
                    <div className="text-sm font-medium text-purple-800">市场信息</div>
                    <div className="text-sm text-purple-700 mt-1">
                      • 同类岗位薪资: 28K-38K<br/>
                      • 市场竞争: 激烈<br/>
                      • 候选人优势: 大厂背景，技术能力强
                    </div>
                  </div>
                  
                  <div className="bg-yellow-50 p-3 rounded">
                    <div className="text-sm font-medium text-yellow-800">情绪分析</div>
                    <div className="text-sm text-yellow-700 mt-1">
                      • 候选人情绪: 积极，有意向<br/>
                      • 关注点: 薪资、发展空间、团队氛围<br/>
                      • 风险点: 其他机会竞争
                    </div>
                  </div>
                </div>
                
                <div className="flex justify-end space-x-2 mt-4">
                  <Button size="sm" variant="outline">编辑信息</Button>
                  <Button size="sm">确认提取</Button>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>

      {/* 情绪与风险识别 */}
      <Card title="情绪与风险识别">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <h4 className="font-medium text-gray-900 mb-3">情绪分析统计</h4>
            <div className="space-y-3">
              <div className="bg-green-50 p-3 rounded-lg text-center">
                <div className="text-2xl font-bold text-green-600">72%</div>
                <div className="text-sm text-green-700">积极情绪</div>
              </div>
              <div className="space-y-2">
                {[
                  { emotion: '积极', percentage: 72, color: 'green' },
                  { emotion: '中性', percentage: 20, color: 'yellow' },
                  { emotion: '消极', percentage: 8, color: 'red' }
                ].map((item, index) => (
                  <div key={index} className="flex items-center justify-between">
                    <span className="text-sm text-gray-700">{item.emotion}</span>
                    <div className="flex items-center space-x-2">
                      <div className="w-16 bg-gray-200 rounded-full h-2">
                        <div className={`bg-${item.color}-500 h-2 rounded-full`} style={{width: `${item.percentage}%`}}></div>
                      </div>
                      <span className="text-sm font-medium">{item.percentage}%</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">风险信号识别</h4>
            <div className="space-y-2">
              {[
                {
                  signal: '薪资期望过高',
                  count: 12,
                  level: 'high',
                  description: '候选人期望超出预算20%以上'
                },
                {
                  signal: '竞争对手接触',
                  count: 8,
                  level: 'medium',
                  description: '候选人提及其他公司机会'
                },
                {
                  signal: '入职意愿下降',
                  count: 5,
                  level: 'high',
                  description: '沟通中表现出犹豫态度'
                },
                {
                  signal: '时间冲突',
                  count: 15,
                  level: 'low',
                  description: '面试时间安排困难'
                }
              ].map((risk, index) => (
                <div key={index} className="p-3 border border-gray-200 rounded">
                  <div className="flex items-center justify-between mb-1">
                    <span className="font-medium text-gray-900 text-sm">{risk.signal}</span>
                    <div className="flex items-center space-x-2">
                      <span className="text-sm text-gray-600">{risk.count}次</span>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        risk.level === 'high' ? 'bg-red-100 text-red-800' :
                        risk.level === 'medium' ? 'bg-yellow-100 text-yellow-800' :
                        'bg-blue-100 text-blue-800'
                      }`}>
                        {risk.level === 'high' ? '高风险' : risk.level === 'medium' ? '中风险' : '低风险'}
                      </span>
                    </div>
                  </div>
                  <div className="text-xs text-gray-600">{risk.description}</div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">AI建议</h4>
            <div className="space-y-3">
              <div className="bg-blue-50 p-3 rounded">
                <h5 className="font-medium text-blue-800 mb-2">处理建议</h5>
                <div className="space-y-1 text-sm text-blue-700">
                  <div>• 对薪资敏感候选人提前沟通预算</div>
                  <div>• 加快高意向候选人的面试流程</div>
                  <div>• 关注竞争对手动态，及时调整策略</div>
                  <div>• 建立候选人关怀机制</div>
                </div>
              </div>
              <div className="space-y-2">
                <Button variant="outline" className="w-full justify-start" size="sm">
                  <i className="ri-settings-line mr-2"></i>
                  配置识别规则
                </Button>
                <Button variant="outline" className="w-full justify-start" size="sm">
                  <i className="ri-alarm-line mr-2"></i>
                  设置预警阈值
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );

  const renderArchiveSync = () => (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">归档与同步 - 智能数据管理</h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="一键确认与写回">
          <div className="space-y-4">
            <div className="bg-green-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-check-double-line text-green-600"></i>
                <span className="font-medium text-green-800">智能同步</span>
              </div>
              <div className="text-sm text-green-700">
                待确认 <span className="font-bold">23</span> 条处理结果
              </div>
            </div>
            
            <div className="space-y-3">
              <h4 className="font-medium text-gray-900">待确认记录</h4>
              {[
                {
                  id: 1,
                  type: '人才信息更新',
                  target: '张三',
                  changes: ['期望薪资: 25K → 35K', '到岗时间: 立即 → 1个月'],
                  confidence: 95,
                  source: '电话录音',
                  time: '2024-01-15 14:30'
                },
                {
                  id: 2,
                  type: '客户需求变更',
                  target: '阿里巴巴-前端工程师',
                  changes: ['紧急程度: 一般 → 紧急', '预算: 30K → 35K'],
                  confidence: 88,
                  source: '邮件沟通',
                  time: '2024-01-15 15:20'
                },
                {
                  id: 3,
                  type: '项目状态更新',
                  target: 'Java后端工程师-腾讯',
                  changes: ['状态: 招聘中 → 面试中', '候选人数: 5 → 8'],
                  confidence: 92,
                  source: '微信群聊',
                  time: '2024-01-15 16:10'
                }
              ].map((record, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <h5 className="font-medium text-gray-900">{record.type}</h5>
                      <p className="text-sm text-gray-600">{record.target}</p>
                    </div>
                    <div className="text-right">
                      <span className="text-sm font-medium text-blue-600">{record.confidence}%置信度</span>
                      <div className="text-xs text-gray-500">{record.source}</div>
                    </div>
                  </div>
                  <div className="space-y-1 mb-3">
                    {record.changes.map((change, i) => (
                      <div key={i} className="text-sm text-gray-700 bg-yellow-50 p-2 rounded">
                        {change}
                      </div>
                    ))}
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">{record.time}</span>
                    <div className="flex space-x-2">
                      <Button size="sm" variant="outline">拒绝</Button>
                      <Button size="sm" variant="outline">修改</Button>
                      <Button size="sm">确认</Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Card>

        <Card title="自动/半自动模式">
          <div className="space-y-4">
            <div className="bg-blue-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-settings-3-line text-blue-600"></i>
                <span className="font-medium text-blue-800">同步模式配置</span>
              </div>
              <div className="text-sm text-blue-700">
                当前模式: <span className="font-bold">半自动</span>
              </div>
            </div>
            
            <div className="space-y-4">
              <div>
                <h4 className="font-medium text-gray-900 mb-3">模式选择</h4>
                <div className="space-y-3">
                  <label className="flex items-center space-x-3 p-3 border border-gray-200 rounded-lg cursor-pointer">
                    <input type="radio" name="sync-mode" defaultChecked className="text-blue-600" />
                    <div>
                      <div className="font-medium text-gray-900">半自动模式</div>
                      <div className="text-sm text-gray-600">高置信度自动同步，低置信度人工确认</div>
                    </div>
                  </label>
                  <label className="flex items-center space-x-3 p-3 border border-gray-200 rounded-lg cursor-pointer">
                    <input type="radio" name="sync-mode" className="text-blue-600" />
                    <div>
                      <div className="font-medium text-gray-900">全自动模式</div>
                      <div className="text-sm text-gray-600">所有识别结果自动同步到系统</div>
                    </div>
                  </label>
                  <label className="flex items-center space-x-3 p-3 border border-gray-200 rounded-lg cursor-pointer">
                    <input type="radio" name="sync-mode" className="text-blue-600" />
                    <div>
                      <div className="font-medium text-gray-900">手动模式</div>
                      <div className="text-sm text-gray-600">所有变更都需要人工确认</div>
                    </div>
                  </label>
                </div>
              </div>
              
              <div>
                <h4 className="font-medium text-gray-900 mb-3">自动同步规则</h4>
                <div className="space-y-2">
                  {[
                    { rule: '置信度 ≥ 90%', action: '自动同步', enabled: true },
                    { rule: '置信度 70-89%', action: '人工确认', enabled: true },
                    { rule: '置信度 < 70%', action: '标记待审', enabled: true },
                    { rule: '敏感字段变更', action: '强制确认', enabled: true }
                  ].map((rule, index) => (
                    <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                      <div>
                        <div className="text-sm font-medium text-gray-900">{rule.rule}</div>
                        <div className="text-xs text-gray-600">{rule.action}</div>
                      </div>
                      <div className="flex items-center">
                        <div className={`w-10 h-6 ${rule.enabled ? 'bg-blue-600' : 'bg-gray-300'} rounded-full relative cursor-pointer`}>
                          <div className={`w-4 h-4 bg-white rounded-full absolute top-1 ${rule.enabled ? 'right-1' : 'left-1'} transition-all`}></div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>

      {/* 同步统计与历史 */}
      <Card title="同步统计与历史记录">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div>
            <h4 className="font-medium text-gray-900 mb-3">今日同步统计</h4>
            <div className="space-y-2">
              <div className="bg-green-50 p-3 rounded-lg text-center">
                <div className="text-2xl font-bold text-green-600">156</div>
                <div className="text-sm text-green-700">成功同步</div>
              </div>
              <div className="bg-yellow-50 p-3 rounded-lg text-center">
                <div className="text-2xl font-bold text-yellow-600">23</div>
                <div className="text-sm text-yellow-700">待确认</div>
              </div>
              <div className="bg-red-50 p-3 rounded-lg text-center">
                <div className="text-2xl font-bold text-red-600">5</div>
                <div className="text-sm text-red-700">同步失败</div>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">数据类型分布</h4>
            <div className="space-y-2">
              {[
                { type: '人才信息', count: 89, color: 'blue' },
                { type: '客户需求', count: 45, color: 'green' },
                { type: '项目状态', count: 32, color: 'purple' },
                { type: '沟通记录', count: 18, color: 'orange' }
              ].map((item, index) => (
                <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <div className="flex items-center space-x-2">
                    <span className={`w-3 h-3 bg-${item.color}-500 rounded-full`}></span>
                    <span className="text-sm text-gray-700">{item.type}</span>
                  </div>
                  <span className="text-sm font-medium text-gray-900">{item.count}</span>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">同步质量</h4>
            <div className="space-y-2">
              <div className="p-2 bg-gray-50 rounded">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm text-gray-700">准确率</span>
                  <span className="text-sm font-medium text-green-600">94.5%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-1">
                  <div className="bg-green-500 h-1 rounded-full" style={{width: '94.5%'}}></div>
                </div>
              </div>
              <div className="p-2 bg-gray-50 rounded">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm text-gray-700">及时性</span>
                  <span className="text-sm font-medium text-blue-600">98.2%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-1">
                  <div className="bg-blue-500 h-1 rounded-full" style={{width: '98.2%'}}></div>
                </div>
              </div>
              <div className="p-2 bg-gray-50 rounded">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm text-gray-700">完整性</span>
                  <span className="text-sm font-medium text-purple-600">91.8%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-1">
                  <div className="bg-purple-500 h-1 rounded-full" style={{width: '91.8%'}}></div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">快速操作</h4>
            <div className="space-y-2">
              <Button variant="outline" className="w-full justify-start" size="sm">
                <i className="ri-check-double-line mr-2"></i>
                批量确认
              </Button>
              <Button variant="outline" className="w-full justify-start" size="sm">
                <i className="ri-refresh-line mr-2"></i>
                重新同步
              </Button>
              <Button variant="outline" className="w-full justify-start" size="sm">
                <i className="ri-history-line mr-2"></i>
                同步历史
              </Button>
              <Button variant="outline" className="w-full justify-start" size="sm">
                <i className="ri-settings-line mr-2"></i>
                同步设置
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );

  const renderAuditTrace = () => (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">审计与回溯 - 完整存证体系</h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="原文与摘要双存证">
          <div className="space-y-4">
            <div className="bg-blue-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-file-shield-line text-blue-600"></i>
                <span className="font-medium text-blue-800">双重存证</span>
              </div>
              <div className="text-sm text-blue-700">
                已存证 <span className="font-bold">1,234</span> 条完整记录
              </div>
            </div>
            
            <div className="space-y-3">
              <h4 className="font-medium text-gray-900">存证记录示例</h4>
              <div className="border border-gray-200 rounded-lg p-4">
                <div className="flex items-center justify-between mb-3">
                  <h5 className="font-medium text-gray-900">张三薪资谈判 - 存证ID: COMM_20240115_001</h5>
                  <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">已存证</span>
                </div>
                
                <div className="space-y-3">
                  <div className="bg-gray-50 p-3 rounded">
                    <div className="flex items-center justify-between mb-2">
                      <span className="font-medium text-gray-800">原始录音</span>
                      <div className="flex space-x-2">
                        <Button size="sm" variant="outline">播放</Button>
                        <Button size="sm" variant="outline">下载</Button>
                      </div>
                    </div>
                    <div className="text-sm text-gray-600">
                      文件: call_20240115_143025.mp3 (12.5MB)<br/>
                      时长: 12分35秒 · 质量: 高清<br/>
                      MD5: a1b2c3d4e5f6...
                    </div>
                  </div>
                  
                  <div className="bg-blue-50 p-3 rounded">
                    <div className="flex items-center justify-between mb-2">
                      <span className="font-medium text-blue-800">ASR转写文本</span>
                      <div className="flex space-x-2">
                        <Button size="sm" variant="outline">查看全文</Button>
                        <Button size="sm" variant="outline">导出</Button>
                      </div>
                    </div>
                    <div className="text-sm text-blue-700">
                      准确率: 96.5% · 字数: 2,456字<br/>
                      "张总监: 张三你好，关于阿里前端工程师这个职位...<br/>
                      张三: 您好张总监，我对这个职位很感兴趣..."
                    </div>
                  </div>
                  
                  <div className="bg-green-50 p-3 rounded">
                    <div className="flex items-center justify-between mb-2">
                      <span className="font-medium text-green-800">AI智能摘要</span>
                      <div className="flex space-x-2">
                        <Button size="sm" variant="outline">编辑</Button>
                        <Button size="sm" variant="outline">重新生成</Button>
                      </div>
                    </div>
                    <div className="text-sm text-green-700">
                      候选人张三对阿里前端岗位表示强烈兴趣，当前薪资25K，期望35K，
                      可接受杭州工作，1个月内到岗。需要进一步了解团队情况和技术栈。
                    </div>
                  </div>
                </div>
                
                <div className="flex items-center justify-between mt-4 pt-3 border-t border-gray-200">
                  <div className="text-xs text-gray-500">
                    存证时间: 2024-01-15 14:35:22 · 操作人: 张总监
                  </div>
                  <Button size="sm" variant="outline">完整审计日志</Button>
                </div>
              </div>
            </div>
          </div>
        </Card>

        <Card title="字段变更历史">
          <div className="space-y-4">
            <div className="bg-purple-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-history-line text-purple-600"></i>
                <span className="font-medium text-purple-800">变更追踪</span>
              </div>
              <div className="text-sm text-purple-700">
                追踪 <span className="font-bold">2,456</span> 次字段变更
              </div>
            </div>
            
            <div className="space-y-3">
              <h4 className="font-medium text-gray-900">变更历史记录</h4>
              <div className="space-y-3">
                {[
                  {
                    time: '2024-01-15 16:30',
                    user: '张总监',
                    target: '张三',
                    field: '期望薪资',
                    oldValue: '25K-30K',
                    newValue: '30K-35K',
                    source: '电话沟通',
                    reason: '候选人重新评估市场价值'
                  },
                  {
                    time: '2024-01-15 15:45',
                    user: '李经理',
                    target: '阿里巴巴-前端工程师',
                    field: '紧急程度',
                    oldValue: '一般',
                    newValue: '紧急',
                    source: '邮件确认',
                    reason: '客户项目时间提前'
                  },
                  {
                    time: '2024-01-15 14:20',
                    user: '王顾问',
                    target: '李四',
                    field: '面试状态',
                    oldValue: '待安排',
                    newValue: '已安排',
                    source: '微信沟通',
                    reason: '确认面试时间'
                  }
                ].map((change, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-4">
                    <div className="flex items-center justify-between mb-2">
                      <div>
                        <span className="font-medium text-gray-900">{change.target}</span>
                        <span className="text-gray-500 ml-2">· {change.field}</span>
                      </div>
                      <span className="text-sm text-gray-500">{change.time}</span>
                    </div>
                    <div className="grid grid-cols-2 gap-4 mb-2">
                      <div className="bg-red-50 p-2 rounded">
                        <div className="text-xs text-red-600 font-medium">变更前</div>
                        <div className="text-sm text-red-800">{change.oldValue}</div>
                      </div>
                      <div className="bg-green-50 p-2 rounded">
                        <div className="text-xs text-green-600 font-medium">变更后</div>
                        <div className="text-sm text-green-800">{change.newValue}</div>
                      </div>
                    </div>
                    <div className="text-sm text-gray-600 mb-2">
                      <span className="font-medium">变更原因:</span> {change.reason}
                    </div>
                    <div className="flex items-center justify-between text-xs text-gray-500">
                      <span>操作人: {change.user} · 来源: {change.source}</span>
                      <Button size="sm" variant="outline">查看详情</Button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Card>
      </div>

      {/* 审计统计与合规检查 */}
      <Card title="审计统计与合规检查">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div>
            <h4 className="font-medium text-gray-900 mb-3">存证统计</h4>
            <div className="space-y-2">
              <div className="bg-blue-50 p-3 rounded-lg text-center">
                <div className="text-2xl font-bold text-blue-600">1,234</div>
                <div className="text-sm text-blue-700">总存证数</div>
              </div>
              <div className="space-y-1">
                {[
                  { type: '电话录音', count: 456, color: 'blue' },
                  { type: '聊天记录', count: 567, color: 'green' },
                  { type: '邮件往来', count: 211, color: 'purple' }
                ].map((item, index) => (
                  <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                    <div className="flex items-center space-x-2">
                      <span className={`w-2 h-2 bg-${item.color}-500 rounded-full`}></span>
                      <span className="text-sm text-gray-700">{item.type}</span>
                    </div>
                    <span className="text-sm font-medium text-gray-900">{item.count}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">合规检查</h4>
            <div className="space-y-2">
              {[
                { item: '数据完整性', status: 'pass', score: 98 },
                { item: '存储安全', status: 'pass', score: 100 },
                { item: '访问控制', status: 'pass', score: 95 },
                { item: '备份策略', status: 'warning', score: 85 }
              ].map((check, index) => (
                <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <div className="flex items-center space-x-2">
                    <span className={`w-2 h-2 rounded-full ${
                      check.status === 'pass' ? 'bg-green-500' : 
                      check.status === 'warning' ? 'bg-yellow-500' : 'bg-red-500'
                    }`}></span>
                    <span className="text-sm text-gray-700">{check.item}</span>
                  </div>
                  <span className="text-sm font-medium text-gray-900">{check.score}%</span>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">访问审计</h4>
            <div className="space-y-2">
              <div className="bg-green-50 p-3 rounded-lg text-center">
                <div className="text-2xl font-bold text-green-600">156</div>
                <div className="text-sm text-green-700">今日访问</div>
              </div>
              <div className="space-y-1">
                {[
                  { user: '张总监', access: 45, time: '16:30' },
                  { user: '李经理', access: 32, time: '15:20' },
                  { user: '王顾问', access: 28, time: '14:15' }
                ].map((user, index) => (
                  <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                    <span className="text-sm text-gray-700">{user.user}</span>
                    <div className="text-right">
                      <div className="text-sm font-medium text-gray-900">{user.access}次</div>
                      <div className="text-xs text-gray-500">{user.time}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">快速操作</h4>
            <div className="space-y-2">
              <Button variant="outline" className="w-full justify-start" size="sm">
                <i className="ri-search-line mr-2"></i>
                审计查询
              </Button>
              <Button variant="outline" className="w-full justify-start" size="sm">
                <i className="ri-download-line mr-2"></i>
                导出审计日志
              </Button>
              <Button variant="outline" className="w-full justify-start" size="sm">
                <i className="ri-shield-check-line mr-2"></i>
                合规检查
              </Button>
              <Button variant="outline" className="w-full justify-start" size="sm">
                <i className="ri-settings-line mr-2"></i>
                审计配置
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">沟通中心</h1>
          <p className="text-gray-600">多渠道沟通记录接入、AI智能处理与审计存证</p>
        </div>

        {/* 标签页导航 */}
        <div className="mb-8">
          <nav className="flex space-x-8">
            {[
              { id: 'data-input', name: '数据接入', icon: 'ri-download-cloud-line' },
              { id: 'ai-processing', name: 'AI处理', icon: 'ri-brain-line' },
              { id: 'archive-sync', name: '归档同步', icon: 'ri-database-line' },
              { id: 'audit-trace', name: '审计回溯', icon: 'ri-file-shield-line' }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 px-4 py-2 border-b-2 font-medium text-sm cursor-pointer whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <i className={`${tab.icon} text-base`}></i>
                <span>{tab.name}</span>
              </button>
            ))}
          </nav>
        </div>

        {/* 标签页内容 */}
        {activeTab === 'data-input' && renderDataInput()}
        {activeTab === 'ai-processing' && renderAIProcessing()}
        {activeTab === 'archive-sync' && renderArchiveSync()}
        {activeTab === 'audit-trace' && renderAuditTrace()}
      </div>
    </div>
  );
}